export enum BorderRadius {
    "_5" = "5px",
    "_12" = "12px",
    input = "4px",
    full = "50%",
}
